	/*******************************************************************************
 * Copyright 2016 Adobe
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 ******************************************************************************/
(function() {
    "use strict";

    function onCheckboxChange(e) {
        var checkboxes = document.querySelectorAll('.cmp-form-options [name="'+e.target.name+'"]');
        var isRequired = true;
        
        for (var checkbox of checkboxes) {
            if (checkbox.checked) {
                isRequired = false;
                break;
            }
        }

        for (var checkbox of checkboxes) {
            checkbox.required = isRequired;
        }
    }

    function onDocumentReady() {
        var checkboxes = document.querySelectorAll('.cmp-form-options [data-cmp-hook-form-option="input"]');
    
        for (var checkbox of checkboxes) {
            checkbox.addEventListener('change', onCheckboxChange);
        }
    }

    if (document.readyState !== "loading") {
        onDocumentReady();
    } else {
        document.addEventListener("DOMContentLoaded", onDocumentReady);
    }

})();